import { render, staticRenderFns } from "./customize_step2.vue?vue&type=template&id=e36a8262&scoped=true"
import script from "./customize_step2.vue?vue&type=script&lang=js"
export * from "./customize_step2.vue?vue&type=script&lang=js"
import style0 from "./customize_step2.vue?vue&type=style&index=0&id=e36a8262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36a8262",
  null
  
)

export default component.exports